import clsx from 'clsx'
import { ChatEngineTrace } from '../ChatEngineTraceViewer'
import { ChatMiddlewareIcon } from '../../ChatMiddlewareIcon'
import { useState } from 'react'

type SummarizedTraceViewProps = {
  trace: ChatEngineTrace
  setSelectedStepIndex: (index: number) => void
}

export function SummarizedTraceView (props: SummarizedTraceViewProps) {
  const { trace, setSelectedStepIndex } = props
  const [selectedSummarizedIndex, setSelectedSummarizedIndex] = useState<number>()

  return (
    <div className='w-max'>
      {trace.steps.filter(step => step.events).map((filteredStep, index) => (
        <div
          key={index}
          className={clsx(
            'px-2',
            'py-1',
            'cursor-pointer',
            'hover:bg-base-200',
            selectedSummarizedIndex === index && 'bg-base-200'
          )}
          onClick={() => {
            setSelectedSummarizedIndex(index)
            const stepIndex = trace.steps.findIndex(s => s === filteredStep)
            setSelectedStepIndex(stepIndex)
          }}
        >
          <div className="flex w-full gap-2 items-center justify-start">
            <div className="bg-yellow-200 p-1 rounded">
              <ChatMiddlewareIcon type={filteredStep.type ?? filteredStep.name as any}/>
            </div>
            <span className="text-sm truncate">{filteredStep.name}</span>
            <span className="text-xs opacity-40">{filteredStep.duration?.toFixed(1)}ms</span>
            <span className="text-xs opacity-70">
              {filteredStep.events?.length === 1 && '1 event'}
              {filteredStep.events?.length && filteredStep.events.length > 1 && `${filteredStep.events?.length} events`}
            </span>
            <span className="text-xs opacity-40">{filteredStep.type}</span>
          </div>
        </div>
      ))}
    </div>
  )
}
